/* ==========================================================================
   DOLERA — theme.js
   Vanilla, dependency-free. Drives header search, mobile menu, cart drawer,
   product carousels, quantity steppers, product gallery + variant selects.
   Cart actions use Shopify's AJAX Cart API (/cart/add.js, /cart.js,
   /cart/change.js) and re-render the drawer from live cart data.
   ========================================================================== */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Shopify money formatting ---------- */
  // Uses the shop's money format when available; falls back to $0.00.
  var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100);
    // Simple {{amount}} substitution (two decimals, comma thousands).
    var amount = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  /* ---------- overlay + panels ---------- */
  function openPanel(el)  { if (!el) return; el.classList.add('open'); var ov = $('#overlay'); if (ov) ov.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeAll() {
    $$('.cart-drawer,.mobile-menu').forEach(function (p) { p.classList.remove('open'); });
    var ov = $('#overlay'); if (ov) ov.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ---------- optimistic UI helpers ---------- */
  // Bump the header cart count immediately, before the network responds.
  // Returns a rollback function in case the add fails.
  function bumpCount(delta) {
    var els = $$('.cart-count');
    var previous = els.map(function (c) { return c.textContent; });
    els.forEach(function (c) {
      var n = (parseInt(c.textContent, 10) || 0) + delta;
      if (n < 0) n = 0;
      c.textContent = n;
      c.style.display = n ? 'flex' : 'none';
      c.classList.add('is-bumped');
      setTimeout(function () { c.classList.remove('is-bumped'); }, 300);
    });
    return function rollback() {
      els.forEach(function (c, i) {
        c.textContent = previous[i];
        var n = parseInt(previous[i], 10) || 0;
        c.style.display = n ? 'flex' : 'none';
      });
    };
  }

  // Brief "Added" state on the button so the user gets feedback
  // without the drawer opening.
  function flashAdded(btn) {
    if (!btn || btn.dataset.flashing === '1') return;
    var original = btn.innerHTML;
    btn.dataset.flashing = '1';
    btn.classList.add('is-added');
    btn.innerHTML = 'Added \u2713';
    setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove('is-added');
      btn.dataset.flashing = '';
    }, 1400);
  }

  /* ---------- Shopify cart API ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- drawer rendering ---------- */
  function renderCart(cart) {
    var body = $('#cart-lines');
    if (body) {
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><div class="serif">Your bag is empty</div><p>Discover something you\u2019ll love.</p></div>';
      } else {
        var html = '';
        cart.items.forEach(function (item, i) {
          var line = i + 1; // Shopify line index is 1-based
          var showMeta = item.variant_title && item.variant_title.indexOf('Default') === -1;
          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" width="74" height="99" loading="lazy">'
            : '';
          html +=
            '<div class="cart-line" data-line-item="' + line + '">' +
              '<a class="cl-media" href="' + item.url + '">' + imgHtml + '</a>' +
              '<div>' +
                '<div class="cl-title">' + escapeHtml(item.product_title) + '</div>' +
                (showMeta ? '<div class="cl-meta">' + escapeHtml(item.variant_title) + '</div>' : '') +
                '<div class="qty" data-qty data-line="' + line + '">' +
                  '<button type="button" data-step="-" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Decrease">\u2212</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-step="+" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Increase">+</button>' +
                '</div>' +
                '<button type="button" class="cl-remove" data-remove data-line="' + line + '" aria-label="Remove">Remove</button>' +
              '</div>' +
              '<div class="cl-price">' + formatMoney(item.final_line_price) + '</div>' +
            '</div>';
        });
        body.innerHTML = html;
      }
    }

    var totalEl = $('#cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    $$('.cart-count').forEach(function (c) {
      c.textContent = cart.item_count;
      c.style.display = cart.item_count ? 'flex' : 'none';
    });

    var shipNote = $('#free-ship-note');
    if (shipNote) {
      var threshold = 9900; // $99 in cents
      var remain = threshold - cart.total_price;
      shipNote.textContent = cart.total_price <= 0 ? 'Free shipping over $99.'
        : (remain > 0 ? 'You\u2019re ' + formatMoney(remain) + ' away from free shipping.'
                      : 'You\u2019ve unlocked free shipping \u2764');
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function refreshCart() {
    return getCart().then(renderCart);
  }

  function bind() {
    /* search toggle */
    var search = $('#search-bar');
    $$('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!search) return;
        search.classList.toggle('open');
        if (search.classList.contains('open')) { var i = $('input', search); if (i) setTimeout(function () { i.focus(); }, 120); }
      });
    });

    /* drawers */
    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openPanel($('#cart-drawer')); }); });
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openPanel($('#mobile-menu')); }); });
    $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    var ov = $('#overlay'); if (ov) ov.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* carousels */
    $$('[data-carousel]').forEach(function (wrap) {
      var track = $('.carousel', wrap);
      if (!track) return;
      var step = function () {
        var card = $('.product-card', track);
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20);
        return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
      };
      var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left:  step() * 2, behavior: 'smooth' }); });
    });

    /* product gallery thumbs */
    var main = $('[data-gallery-main]');
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (!main) return;
        var src = t.getAttribute('data-src');
        var img = $('img', main);
        if (src && img) img.src = src;
      });
    });

    /* swatches + sizes (toggle + variant sync on PDP) */
    ['.swatch', '.size-box', '.chip'].forEach(function (sel) {
      $$(sel).forEach(function (el) {
        el.addEventListener('click', function () {
          var sibs = el.parentElement ? $$(sel, el.parentElement) : [];
          sibs.forEach(function (s) { s.classList.remove('active'); });
          el.classList.add('active');
          if (sel !== '.chip') syncVariant();
        });
      });
    });

    /* PDP quantity stepper → hidden input (single source of truth) */
    var pdpQtyWrap = $('.product-actions [data-qty]');
    if (pdpQtyWrap) {
      var hidden = $('#pdp-qty');
      var out = $('span', pdpQtyWrap);
      $$('button', pdpQtyWrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(hidden ? hidden.value : out.textContent, 10) || 1;
          v += (btn.dataset.step === '-' ? -1 : 1);
          if (v < 1) v = 1;
          if (out) out.textContent = v;
          if (hidden) hidden.value = v;
        });
      });
    }

    /* Add to cart — works from the product page (has #variant-select + #pdp-qty)
       and from product cards (own hidden <input name="id">). */
    $$('[data-add-to-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        // Stop the native form submit AND the parent product-card <a> navigation.
        e.preventDefault();
        e.stopPropagation();
        if (b.disabled) return;
        // Guard against double-fire from a rapid double-click. Not a visual
        // disable — the button stays responsive-looking for instant feel.
        if (b.dataset.adding === '1') return;
        b.dataset.adding = '1';

        // Resolve the variant id: product-page select first, else the
        // hidden <input name="id"> inside this button's own form (card).
        var id = null;
        var pageSelect = $('#variant-select');
        if (pageSelect && pageSelect.value) {
          id = pageSelect.value;
        } else {
          var form = b.closest('form');
          var hiddenId = form ? form.querySelector('input[name="id"]') : null;
          if (hiddenId) id = hiddenId.value;
        }

        // Quantity only exists on the product page; cards default to 1.
        var qtyInput = $('#pdp-qty');
        var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        if (!id) { b.dataset.adding = ''; alert('Sorry, this item is unavailable.'); return; }

        // --- Optimistic UI: update instantly, reconcile after ---
        // The user sees the count bump and "Added" the moment they click;
        // the network request runs in the background.
        var rollback = bumpCount(quantity);
        flashAdded(b);

        addToCart(id, quantity)
          .then(function () {
            // Reconcile with the real cart (drawer contents, subtotal, exact count).
            return refreshCart();
          })
          .catch(function (err) {
            // Undo the optimistic bump — the item never made it in.
            rollback();
            var msg = (err && err.description) ? err.description : 'Sorry, this item could not be added.';
            alert(msg);
          })
          .then(function () { b.dataset.adding = ''; });
      });
    });

    /* Drawer: remove + quantity (event delegation, real Shopify change) */
    var drawer = $('#cart-drawer');
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-remove]');
        if (removeBtn) {
          e.preventDefault();
          applyChange(drawer, parseInt(removeBtn.getAttribute('data-line'), 10), 0);
          return;
        }
        var stepBtn = e.target.closest('[data-step]');
        if (stepBtn) {
          e.preventDefault();
          var line = parseInt(stepBtn.getAttribute('data-line'), 10);
          var current = parseInt(stepBtn.getAttribute('data-quantity'), 10) || 0;
          var next = stepBtn.getAttribute('data-step') === '+' ? current + 1 : current - 1;
          if (next < 0) next = 0;
          applyChange(drawer, line, next);
        }
      });
    }

    /* Initial paint from the real cart */
    refreshCart();
  }

  function applyChange(drawer, line, quantity) {
    var row = drawer.querySelector('[data-line-item="' + line + '"]');
    if (row) row.setAttribute('aria-busy', 'true');
    changeLine(line, quantity)
      .then(renderCart)
      .catch(function () { if (row) row.removeAttribute('aria-busy'); });
  }

  /* ---------- variant matching (PDP) ---------- */
  function syncVariant() {
    var select = $('#variant-select');
    if (!select) return;
    var chosen = $$('.opt-group').map(function (g) {
      var active = $('.swatch.active,.size-box.active', g);
      return active ? active.getAttribute('data-value') : null;
    }).filter(Boolean);
    if (!chosen.length) return;
    $$('option', select).forEach(function (opt) {
      var label = opt.textContent.split(' - ')[0];
      var parts = label.split(' / ').map(function (s) { return s.trim(); });
      var match = chosen.every(function (v) { return parts.indexOf(v) !== -1; });
      if (match) {
        select.value = opt.value;
        var addBtn = $('[data-add-to-cart][name="add"]');
        if (addBtn) addBtn.disabled = opt.disabled;
        var priceTxt = opt.textContent.split(' - ')[1];
        var priceEl = $('#pdp-price');
        if (priceTxt && priceEl && !priceEl.querySelector('.compare')) priceEl.textContent = priceTxt;
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
